<template>
  <b-card title="تسویه ها">
    <b-row>
      <div class="col-md-4" v-for="item in gatewayList" v-bind:key="item.id">
        <b-card
          no-body
          class="mt-2"
          style="cursor: pointer"
          @click="gotoShareAndSettlement(item.id)"
        >
          <b-card-body>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="symbol symbol-lg-120">
                   <b-img
                
                style="height: auto"
                  :src="'http://api.shepa.com/api/file/' + item.logo"
                  
                ></b-img>
                </div>
               
              </div>
              <div class="col-md-8 col-sm-12">
                <h4>{{ item.website_name }}</h4>
                <b-row>
                    <b-col>
                        {{ item.website }}
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col class="p-3">{{item.payment_priority == 1704?" مبلغ قابل تسویه: ":"موجودی در حال حاضر:"}}</b-col>
                  <b-col
                    class="text-center text-light p-3"
                    style="background-color: #0d7d65; border-radius: 5px"
                    :class="item.payment_priority == 1704?'bg-success':'bg-warning'"
                  >
                    {{ Number(item.payment_priority == 1704?item.CanPaydBySharing:item.CanPaydTomorow).toLocaleString() }} ريال
                  </b-col>
                </b-row>
                <!-- <b-row class="mt-5">
                  <b-col class="p-3"> مبلغ در حال تسویه: </b-col>
                  <b-col
                    class="text-center text-dark p-3"
                    style="background-color: #f3f6f9; border-radius: 5px"
                  >
                    {{ Number(item.waiting).toLocaleString() }} ريال
                  </b-col>
                </b-row> -->
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "sharegateways",
  data() {
    return {
      gatewayList: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تسویه حساب" }]);
    httpHelper.getData("share/gateways").then((res) => {
      this.gatewayList = res.result;
    });
  },
  methods:{
    gotoShareAndSettlement(id){
      this.$router.push('share/' + id);
    }
  }
};
</script>